import React from 'react';
import PropTypes from 'prop-types';
import Invite from '../../../components/invite';
import UserList from '../../../components/userList';
import EditAccess from '../../../components/user/editAccess';
import JiraUserMappingModal from '../../integration_settings/JiraUserMappingModal';
import ClickupUserMappingModal from '../../integration_settings/ClickupUserMappingModal';
import TrelloUserMappingModal from '../../integration_settings/TrelloUserMappingModal';
import MondayUserMappingModal from '../../integration_settings/MondayUserMappingModal';
import LinearUserMappingModal from '../../integration_settings/LinearUserMappingModal';
import AsanaUserMappingModal from '../../integration_settings/AsanaUserMappingModal';
import ProductiveUserMappingModal from '../../integration_settings/ProductiveUserMappingModal';
import { Progress, Input, Button, Tag } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { updateOrganization } from '../organization';
import styles from './index.module.css';
import * as translations from './strings';
import { getLangKey } from 'appJS/models/Application';

const strings = translations[getLangKey()];

export default class Team extends React.Component<any, any> {
  static propTypes = {
    authenticityToken: PropTypes.string,
    commit: PropTypes.string,
    container: PropTypes.func,
    filter: PropTypes.string,
    membersMax: PropTypes.number,
    orgId: PropTypes.number,
    parentSetState: PropTypes.func,
    project: PropTypes.bool,
    presetRole: PropTypes.string,
    responseError: PropTypes.string,
    role: PropTypes.string,
    saving: PropTypes.bool,
    searchTerm: PropTypes.string,
    sendInvite: PropTypes.func,
    successful: PropTypes.string,
    updateUser: PropTypes.func,
    users: PropTypes.array,
    validation: PropTypes.bool,
    projects: PropTypes.array,
    access_to: PropTypes.array,
    user: PropTypes.object,
    organizations: PropTypes.array
  };

  state = {
    role: 'member',
    showAddedUserAccessModal: undefined,
    sso_allowed_domains:
      this.props.organizations.find(
        org => org.organization.id === this.props.orgId
      )?.organization.sso_allowed_domains || [],
    inputVisible: false,
    inputValue: '',
    showJiraUserMappingModal:
      new URLSearchParams(window.location.search).get('manage_jira_users') ===
      'true',
    showClickupUserMappingModal:
      new URLSearchParams(window.location.search).get('manage_clickup_users') ===
      'true',
    showTrelloUserMappingModal:
      new URLSearchParams(window.location.search).get('manage_trello_users') ===
      'true',
    showMondayUserMappingModal:
      new URLSearchParams(window.location.search).get('manage_monday_users') ===
      'true',
    showLinearUserMappingModal:
      new URLSearchParams(window.location.search).get('manage_linear_users') ===
      'true',
    showAsanaUserMappingModal:
      new URLSearchParams(window.location.search).get('manage_asana_users') ===
      'true',
    showProductiveUserMappingModal:
      new URLSearchParams(window.location.search).get(
        'manage_productive_users'
      ) === 'true'
  };

  input: any;

  debounceTimeout: any = null;

  getAccessTo = () => {
    return this.props.access_to.find(
      obj => obj.organization_id === this.props.orgId
    );
  };

  getCurrentOrganization = () =>
    this.props.organizations.find(
      org => org.organization.id === this.props.orgId
    );

  handleInvitedUser = _user => {
    const user = Object.assign({}, _user, {
      on_projects: []
    });

    window.settings_props.organizations
      .find(org => org.organization.id === this.props.orgId)
      .users.push(user);

    this.setState({
      showAddedUserAccessModal: user
    });
  };

  handleRemovedUser = id => {
    const currentOrg = this.getCurrentOrganization();
    const index = currentOrg.users.findIndex(user => user.id === id);

    window.settings_props.organizations
      .find(org => org.organization.id === this.props.orgId)
      .users.splice(index, 1);
  };

  handleUpdateUser = user => {
    Object.assign(
      window.settings_props.organizations
        .find(org => org.organization.id === this.props.orgId)
        .users.find(_user => _user.id === user.id),
      user
    );
  };

  clearField = (field, ref) => {
    ref.focus();
    this.setState({
      [field]: null
    });
  };

  parentSetState = obj => {
    this.setState(obj);
  };

  getUsers = () => this.getCurrentOrganization().users;

  getCurrentUser = () =>
    this.getCurrentOrganization().users.find(
      user => user.id === this.props.user.id
    );

  getMembersCount = () =>
    this.getUsers().filter(
      user => user.role !== 'guest' && user.role !== 'collaborator'
    ).length;

  getBillingCTA = seatsLeft => {
    if (seatsLeft > 2 || !this.getAccessTo().billing) {
      return null;
    }

    return (
      <span>
        . {strings.needMore}
        <a href={`/organizations/${this.props.orgId}/subscription`}>
          {strings.upgradeHere}
        </a>
        .
      </span>
    );
  };

  getMemberLimitMessage = () => {
    const organization = this.getCurrentOrganization().organization;
    const hasUnlimited = organization.max_members === null;
    return (
      <div className={styles.feedbackBox}>
        <p className={styles.membersFeedback}>
          {strings.youAreCurrentlyUsing}
          <strong className={styles.memberCount}>
            {` ${this.getMembersCount()} member${this.getMembersCount() !== 1 ? 's' : ''
              } `}
          </strong>
          {!hasUnlimited && (
            <span className={styles.memberLimitInfo}>
              {strings.outOf}
              <strong className={styles.memberCount}>
                {organization.max_members + ' total'}
              </strong>
              {this.getBillingCTA(
                organization.max_members - this.getMembersCount()
              )}
            </span>
          )}
        </p>

        {!hasUnlimited && (
          <Progress
            className={styles.progressBar}
            percent={Math.round(
              (this.getMembersCount() / organization.max_members) * 100
            )}
            showInfo={false}
            strokeColor="#1CB8E3"
          />
        )}
      </div>
    );
  };

  setPopOverToShow = () => {
    return;
  };

  handleClose = removedDomain => {
    const domains = this.state.sso_allowed_domains.filter(
      domain => domain !== removedDomain
    );
    this.setState({ sso_allowed_domains: domains }, this.handleSaveSSO);
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = e => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { sso_allowed_domains } = this.state;
    if (inputValue && !sso_allowed_domains.includes(inputValue)) {
      sso_allowed_domains = [...sso_allowed_domains, inputValue];
    }
    this.setState(
      {
        sso_allowed_domains,
        inputVisible: false,
        inputValue: ''
      },
      this.handleSaveSSO
    );
  };

  saveInputRef = input => (this.input = input);

  handleSaveSSO = async () => {
    await updateOrganization({
      organizationId: this.props.orgId,
      body: { sso_allowed_domains: this.state.sso_allowed_domains },
      showSuccess: false
    });
  };

  renderSingleSignOn = () => {
    const { sso_allowed_domains, inputVisible, inputValue } = this.state;
    const organization = this.getCurrentOrganization().organization;

    if (organization["sso_enabled?"]) {
      return (
        <div className={styles.ssoDomainsContainer}>
          <p>Require SSO login for the following domains:</p>
          <div
            style={{
              marginTop: 16,
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px',
              alignItems: 'center'
            }}
          >
            {sso_allowed_domains.map(domain => (
              <Tag
                key={domain}
                closable
                className={styles.ssoDomainTag}
                onClose={e => {
                  e.preventDefault();
                  this.handleClose(domain);
                }}
              >
                {domain}
              </Tag>
            ))}
            {!inputVisible && (
              <Tag onClick={this.showInput} className={styles.ssoDomainTagButton}>
                <PlusOutlined /> Add domain
              </Tag>
            )}
          </div>
          <div style={{ marginTop: 8 }}>
            {inputVisible && (
              <Input
                ref={this.saveInputRef}
                type="text"
                style={{ width: 250 }}
                value={inputValue}
                onChange={this.handleInputChange}
                onBlur={this.handleInputConfirm}
                onPressEnter={this.handleInputConfirm}
              />
            )}
          </div>
        </div>
      );
    }
  };

  render() {
    const { authenticityToken, container } = this.props;
    const organization = this.getCurrentOrganization().organization;
    const projects = this.getCurrentOrganization().projects;
    const users = this.getUsers();

    const queryParams = new URLSearchParams(window.location.search);
    const integrationId = queryParams.get('integration_id');
    const projectIntegrationId = queryParams.get('project_integration_id');
    const siteId = queryParams.get('site_id');
    const workspaceId = queryParams.get('workspace_id');
    const listId = queryParams.get('list_id');
    const boardId = queryParams.get('board_id');
    const teamId = queryParams.get('team_id');
    const productiveProjectId = queryParams.get('productive_project_id');

    return (
      <div className={styles.manageAccessContainer}>
        <h3>{strings.teamMembers}</h3>
        {this.getMemberLimitMessage()}
        <Invite
          authenticityToken={authenticityToken}
          container={container}
          endpoint={{
            sendEmail: this.getCurrentOrganization().endpoints.addMembers,
            fetchUsers: null
          }}
          membersCount={this.getMembersCount()}
          membersMax={organization.max_members}
          parentSetState={this.parentSetState}
          role={this.state.role}
          success={` has been invited to ${organization.name}`}
          onInvitedUser={this.handleInvitedUser}
          users={users}
          collaboratorsEnabled={this.getAccessTo().collaborators}
          billingRights={this.getAccessTo().billing}
          orgId={this.props.orgId}
        />
        {this.renderSingleSignOn()}
        <h3 className={styles.tabHeader}>{strings.members}</h3>
        <p className={styles.accessLabel}>
          {strings.followingPeople}
        </p>
        <UserList
          authenticityToken={authenticityToken}
          clearField={this.clearField}
          container={container}
          responseError="Something went wrong. Please try again."
          endpoints={this.getCurrentOrganization().endpoints}
          onRemovedUser={this.handleRemovedUser}
          projects={projects}
          success={{
            remove: ` has been removed from ${organization.name}`,
            role: ` role has been updated for ${organization.name}`,
            resend: ` has been resent an invite to join ${organization.name}`
          }}
          users={users}
          collaboratorsEnabled={this.getAccessTo().collaborators}
          canChangeOwner={this.getCurrentOrganization().plan != null}
          hasAdminRights={this.getAccessTo().admin}
          onUpdateUser={this.handleUpdateUser}
          user={this.getCurrentUser()}
        />

        {this.state.showAddedUserAccessModal && (
          <EditAccess
            container={container}
            projects={projects}
            member={this.state.showAddedUserAccessModal}
            show
            endpoint={this.getCurrentOrganization().endpoints.updateUserProject}
            toggleModal={() => {
              this.setState({
                showAddedUserAccessModal: undefined
              });
            }}
            responseError="Something went wrong. Please try again."
            authenticityToken={authenticityToken}
            onUpdateUser={this.handleUpdateUser}
          />
        )}

        <JiraUserMappingModal
          open={this.state.showJiraUserMappingModal}
          onClose={() => this.setState({ showJiraUserMappingModal: false })}
          organizationId={this.props.orgId}
          integrationId={integrationId}
          projectIntegrationId={projectIntegrationId}
          siteId={siteId}
          bugherdUsers={users}
          container={container}
        />

        <ClickupUserMappingModal
          open={this.state.showClickupUserMappingModal}
          onClose={() => this.setState({ showClickupUserMappingModal: false })}
          organizationId={this.props.orgId}
          integrationId={integrationId}
          projectIntegrationId={projectIntegrationId}
          workspaceId={workspaceId}
          listId={listId}
          bugherdUsers={users}
          container={container}
        />
        <TrelloUserMappingModal
          open={this.state.showTrelloUserMappingModal}
          onClose={() => this.setState({ showTrelloUserMappingModal: false })}
          organizationId={this.props.orgId}
          integrationId={integrationId}
          projectIntegrationId={projectIntegrationId}
          boardId={boardId}
          bugherdUsers={users}
          container={container}
        />
        <MondayUserMappingModal
          open={this.state.showMondayUserMappingModal}
          onClose={() => this.setState({ showMondayUserMappingModal: false })}
          organizationId={this.props.orgId}
          integrationId={integrationId}
          projectIntegrationId={projectIntegrationId}
          boardId={boardId}
          bugherdUsers={users}
          container={container}
        />
        <LinearUserMappingModal
          open={this.state.showLinearUserMappingModal}
          onClose={() => this.setState({ showLinearUserMappingModal: false })}
          organizationId={String(this.props.orgId)}
          integrationId={integrationId}
          projectIntegrationId={projectIntegrationId}
          teamId={teamId}
          bugherdUsers={users}
          container={container}
        />
        <AsanaUserMappingModal
          open={this.state.showAsanaUserMappingModal}
          onClose={() => this.setState({ showAsanaUserMappingModal: false })}
          organizationId={String(this.props.orgId)}
          integrationId={integrationId}
          projectIntegrationId={projectIntegrationId}
          workspaceId={workspaceId}
          bugherdUsers={users}
          container={container}
        />
        <ProductiveUserMappingModal
          open={this.state.showProductiveUserMappingModal}
          onClose={() =>
            this.setState({ showProductiveUserMappingModal: false })
          }
          organizationId={String(this.props.orgId)}
          integrationId={integrationId}
          projectIntegrationId={projectIntegrationId}
          productiveProjectId={productiveProjectId}
          bugherdUsers={users}
          container={container}
        />
      </div>
    );
  }
}
